<!-- <h1>Hola mundo</h1>
<h2>{{title}}</h2> -->
<!-- <app-loading *ngIf="(loading$ | async)" ></app-loading> 
<router-outlet *ngIf="!(loading$ | async)"></router-outlet> -->


<router-outlet></router-outlet>
